<template>
  <el-dialog
    title="审核一日三检记录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
    top="5vh"
  >
    <div class="audit-dialog" v-loading="loading">
      <div v-if="inspectionData && inspectionData.length > 0">
        <div v-for="(phaseData, phaseIndex) in inspectionData" :key="phaseIndex" class="phase-section">
          <div class="phase-title">
            <el-tag :type="getPhaseType(phaseData.phase)" size="medium">
              {{ phaseData.phase_text || '未知阶段' }}
            </el-tag>
          </div>
          
          <div v-for="(category, categoryIndex) in phaseData.categories" :key="categoryIndex" class="category-section">
            <div class="category-header">
              <span class="category-name">{{ category.category_name }}</span>
              <div class="category-stats">
                <el-tag size="mini" type="success">正常: {{ category.normal_count }}</el-tag>
                <el-tag size="mini" type="danger">异常: {{ category.abnormal_count }}</el-tag>
                <el-tag size="mini" type="info">总计: {{ category.total_count }}</el-tag>
              </div>
            </div>
            
            <div class="items-container">
              <div v-for="(item, itemIndex) in category.items" :key="itemIndex" class="item-card">
                <div class="item-header">
                  <span class="item-name">{{ item.inspection_detail.name }}</span>
                  <el-tag 
                    :type="item.check_result.checked ? 'success' : 'danger'" 
                    size="small"
                  >
                    {{ item.check_result.checked ? '正常' : '异常' }}
                  </el-tag>
                </div>
                
                <div class="item-content">
                  <div v-if="item.check_result.description" class="item-description">
                    <span class="label">描述：</span>
                    <span>{{ item.check_result.description }}</span>
                  </div>
                  
                  <div v-if="item.check_result.images && item.check_result.images.length > 0" class="item-images">
                    <span class="label">图片：</span>
                    <div class="image-list">
                      <el-image
                        v-for="(img, imgIndex) in item.check_result.images"
                        :key="imgIndex"
                        :src="img"
                        :preview-src-list="item.check_result.images"
                        fit="cover"
                        class="preview-image"
                        style="width: 80px; height: 80px; margin-right: 10px;"
                      >
                      </el-image>
                    </div>
                  </div>
                  
                  <div class="item-meta">
                    <el-tag size="mini" type="info">{{ item.record_phase_text }}</el-tag>
                    <el-tag size="mini">{{ item.source === 'main' ? '主车' : '挂车' }}</el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div v-else class="no-data">
        <el-empty description="暂无检查数据"></el-empty>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取消</el-button>
      <el-button type="danger" @click="handleReject" :loading="submitLoading">驳回</el-button>
      <el-button type="primary" @click="handleApprove" :loading="submitLoading">通过</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  name: 'AuditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inspectionThreeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      inspectionData: []
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.loadInspectionData();
        }
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    async loadInspectionData() {
      if (!this.inspectionThreeId) {
        this.$message.warning('缺少检查记录ID');
        return;
      }
      
      this.loading = true;
      try {
        const response = await AfuncApi.call({
          model: 'inspection_three',
          action: 'detailx',
          inspection_three_id: this.inspectionThreeId
        });
        
        if (response.code === 1 && response.data) {
          this.inspectionData = response.data || [];
        } else {
          this.$message.error(response.msg || '获取检查数据失败');
          this.inspectionData = [];
        }
      } catch (error) {
        console.error('获取检查数据失败:', error);
        this.$message.error('获取检查数据失败，请稍后重试');
        this.inspectionData = [];
      } finally {
        this.loading = false;
      }
    },
    
    getPhaseType(phase) {
      const typeMap = {
        0: 'info',
        1: 'warning',
        2: 'danger'
      };
      return typeMap[phase] || 'info';
    },
    
    async handleApprove() {
      this.$confirm('确定要通过审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitAudit(2);
      }).catch(() => {});
    },
    
    async handleReject() {
      this.$prompt('请输入驳回原因', '驳回审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '驳回原因不能为空'
      }).then(({ value }) => {
        this.submitAudit(3, value);
      }).catch(() => {});
    },
    
    async submitAudit(status, rejectReason = '') {
      this.submitLoading = true;
      try {
        const response = await AfuncApi.call({
          model: 'inspection_three',
          action: 'aduit',
          inspection_three_id: this.inspectionThreeId,
          status: status,
          reject_reason: rejectReason
        });
        
        if (response.code === 1) {
          this.$message.success('审核操作成功');
          this.$emit('success');
          this.dialogFormVisible();
        } else {
          this.$message.error(response.msg || '审核操作失败');
        }
      } catch (error) {
        console.error('审核操作失败:', error);
        this.$message.error('审核操作失败，请稍后重试');
      } finally {
        this.submitLoading = false;
      }
    },
    
    dialogFormVisible() {
      this.dialogVisible = false;
      this.inspectionData = [];
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.audit-dialog {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 10px;
}

.phase-section {
  margin-bottom: 30px;
}

.phase-title {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.category-section {
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
}

.category-name {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
}

.category-stats {
  display: flex;
  gap: 8px;
}

.items-container {
  padding: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.item-card {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  background-color: #fff;
  transition: all 0.3s;
}

.item-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.item-name {
  font-weight: 500;
  font-size: 14px;
  color: #303133;
}

.item-content {
  font-size: 13px;
}

.item-description {
  margin-bottom: 8px;
  color: #606266;
}

.item-description .label {
  color: #909399;
  margin-right: 5px;
}

.item-images {
  margin-bottom: 8px;
}

.item-images .label {
  display: block;
  color: #909399;
  margin-bottom: 5px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.item-meta {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.no-data {
  text-align: center;
  padding: 40px 0;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/inspection_three/index/part/AuditDialog.vue